import { equals } from 'ramda';
import { Observable } from 'rxjs';
import { startWith, withLatestFrom } from 'rxjs/operators';

export const filterOutMatchingDestination =
  <U>(origin$: Observable<U>, keyToCompare?: string) =>
  <T extends U>(destination$: Observable<T>): Observable<T | null> =>
    destination$.pipe(
      withLatestFrom(origin$.pipe(startWith(null)), (destination, origin) => {
        if (keyToCompare) {
          return origin?.[keyToCompare] === destination?.[keyToCompare]
            ? null
            : destination;
        }
        return equals(origin, destination) ? null : destination;
      }),
    );
